var _defs, _g, _circle, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZeroAptGreenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1119.28 370.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_18-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_sin_nombre_18);\n      }\n\n      .cls-4 {\n        fill: #40af65;\n      }\n\n      .cls-5 {\n        fill: none;\n        stroke: #40af65;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_18",
    "data-name": "Degradado sin nombre 18",
    x1: 170.54,
    y1: 224.08,
    x2: 170.54,
    y2: 135.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40af65",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#40af65",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40af65",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40af65",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#40af65",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#40af65",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#40af65",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#40af65",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40af65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_18-2",
    "data-name": "Degradado sin nombre 18",
    x1: 200.14,
    y1: 233.03,
    x2: 200.14,
    y2: 141.57,
    xlinkHref: "#Degradado_sin_nombre_18"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.28,225.26h62.88v20.65h-95v-15.08l61.68-88.83h-61.59v-20.82h93.54v14.73l-61.51,89.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M517.57,247.61c-13.59,0-24.66-4.17-33.19-12.51-8.54-8.34-12.81-19.45-12.81-33.32v-2.4c0-9.31,1.8-17.63,5.4-24.97,3.6-7.34,8.7-12.99,15.29-16.96,6.6-3.97,14.12-5.95,22.57-5.95,12.68,0,22.66,4,29.94,11.99,7.28,8,10.92,19.33,10.92,34.01v10.11h-59.02c.8,6.05,3.21,10.91,7.24,14.56,4.03,3.66,9.12,5.48,15.29,5.48,9.54,0,16.99-3.46,22.36-10.37l12.16,13.62c-3.71,5.25-8.74,9.35-15.08,12.29s-13.36,4.41-21.07,4.41Zm-2.83-76.15c-4.91,0-8.9,1.66-11.95,4.99-3.06,3.33-5.01,8.09-5.87,14.28h34.44v-1.98c-.11-5.51-1.6-9.77-4.45-12.78-2.86-3.01-6.91-4.52-12.16-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M621.83,176.43c-3.37-.46-6.34-.69-8.91-.69-9.37,0-15.5,3.17-18.42,9.51v60.65h-24.76v-92.69h23.39l.69,11.05c4.97-8.51,11.85-12.76,20.64-12.76,2.74,0,5.31,.37,7.71,1.11l-.34,23.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M626.79,198.7c0-9.19,1.77-17.39,5.31-24.58,3.54-7.2,8.64-12.76,15.29-16.7,6.65-3.94,14.38-5.91,23.17-5.91,12.51,0,22.71,3.83,30.62,11.48,7.91,7.65,12.32,18.05,13.23,31.18l.17,6.34c0,14.22-3.97,25.63-11.91,34.22-7.94,8.6-18.59,12.89-31.95,12.89s-24.03-4.28-31.99-12.85c-7.97-8.57-11.95-20.22-11.95-34.95v-1.11Zm24.76,1.76c0,8.81,1.66,15.54,4.97,20.2,3.31,4.66,8.05,6.99,14.22,6.99s10.68-2.3,14.05-6.91c3.37-4.6,5.05-11.97,5.05-22.09,0-8.64-1.69-15.33-5.05-20.08-3.37-4.75-8.11-7.12-14.22-7.12s-10.74,2.36-14.05,7.08c-3.31,4.72-4.97,12.03-4.97,21.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M801.89,220.2h-45.06l-8.57,25.7h-27.32l46.43-124.72h23.81l46.69,124.72h-27.33l-8.65-25.7Zm-38.12-20.82h31.18l-15.68-46.69-15.5,46.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M875.21,201.96v43.94h-25.7V121.18h48.66c9.37,0,17.6,1.71,24.71,5.14,7.11,3.43,12.58,8.3,16.4,14.61,3.83,6.31,5.74,13.49,5.74,21.54,0,12.22-4.18,21.86-12.55,28.91-8.37,7.05-19.95,10.58-34.74,10.58h-22.53Zm0-20.82h22.96c6.8,0,11.98-1.6,15.55-4.8,3.57-3.2,5.35-7.77,5.35-13.71s-1.8-11.05-5.4-14.82c-3.6-3.77-8.57-5.71-14.9-5.83h-23.56v39.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1056.56,141.99h-38.2v103.91h-25.7v-103.91h-37.69v-20.82h101.59v20.82Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 184.76,
    cy: 184.4,
    r: 122.04
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "115.67 147.73 111.26 147.73 111.26 110.99 148.01 110.99 148.01 115.4 115.67 115.4 115.67 147.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "258.26 147.73 253.84 147.73 253.84 115.4 221.51 115.4 221.51 110.99 258.26 110.99 258.26 147.73"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "258.26 257.81 221.51 257.81 221.51 253.39 253.84 253.39 253.84 221.06 258.26 221.06 258.26 257.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "148.01 257.81 111.26 257.81 111.26 221.06 115.67 221.06 115.67 253.39 148.01 253.39 148.01 257.81"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188.24,199.28h-18.94c-1.25,0-2.38-.75-2.86-1.91-.48-1.16-.21-2.49,.67-3.37l19.89-19.89h-17.8c-1.24,0-2.36-.74-2.85-1.88-.49-1.14-.24-2.46,.62-3.36l28.39-29.5-10.61-3.6-39.05,13.26v53.05l27.77,22,14.77-24.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.84,141.57l-25.36,26.36h18c1.25,0,2.38,.75,2.86,1.91,.48,1.16,.21,2.49-.67,3.37l-19.89,19.89h16.91c1.11,0,2.14,.6,2.69,1.56,.55,.97,.54,2.16-.03,3.11l-17.98,30.19,6.39,5.07,39.05-30.95v-53.05l-21.97-7.46Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroAptGreenWhite);
export default __webpack_public_path__ + "static/media/ZeroAPT-GreenWhite.8c85960f2292fb24e309986c218c200c.svg";
export { ForwardRef as ReactComponent };